import { FormButtonGroup, FormTextInput } from "@/components/form";
import { FormInputValidationNumber } from "@/pages/signup/components/forminputinvalidationnumber";
import Close from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

interface IFormInput {
  confirmationCode: string;
  code: string;
}

export default function ConfirmTokenDialog({
  isOpen,
  handleClose,
  onConfirm,
}: IProps) {
  const { control, handleSubmit, watch } = useForm<IFormInput>({
    defaultValues: {
      confirmationCode: "",
      code: "",
    },
  });

  const [loading, setLoading] = useState(false);
  const onSubmit = async () => {
    setLoading(true);
    onConfirm();
    handleClose();
    setLoading(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogContent>
        <Stack direction="row" justifyContent="space-between">
          <Typography sx={{ flexGrow: 1, textAlign: "center" }} variant="h6">
            Token de autorização
          </Typography>
          <Tooltip title="Fechar">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack spacing={2}>
          <Stack spacing={4}>
            <FormInputValidationNumber
              required
              name="confirmationCode"
              control={control}
              label=""
              pattern={[1 - 9]}
              autoFocus
            />

            <FormTextInput
              required
              name="code"
              control={control}
              label="Token de autorização"
            />
          </Stack>
          <FormButtonGroup
            onGoBackButtonClick={() => handleClose()}
            onNextButtonClick={handleSubmit(onSubmit)}
            goBackButtonText="Voltar"
            nextButtonText="Salvar"
            disabled={!watch("code") && !watch("confirmationCode")}
            loading={loading}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
